import { render, staticRenderFns } from "./ProjectFormServices.vue?vue&type=template&id=03ccfce6"
import script from "./ProjectFormServices.vue?vue&type=script&lang=ts"
export * from "./ProjectFormServices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports